import GhostContentAPI from "@tryghost/content-api";
import Head from "next/head";
import SingleService from "../../components/SingleItem/SingleService";
import {ENDPOINTS, TAGS} from "../../utils/api-endpoints";
import {redirectTo500} from "../../utils/utility";

export async function getStaticProps() {
    const PAGE_SLUG = ENDPOINTS.SERVICES;

    // Connection to Ghost
    const api = new GhostContentAPI({
        url: process.env.BLOG_URL,
        key: process.env.CONTENT_API_KEY,
        version: process.env.VERSION,
    });
    // Fetch page data frm Ghost
    let pageData = await api.pages
        .read({slug: PAGE_SLUG})
        .then(page => {
            return page;
        })
        .catch(err => {
            console.error(err);
        });
    // Fetch posts related to this page from Ghost
    let postsData = await api.posts
        .browse({
            filter: "tag:" + TAGS.SERVICE,
            include: "date,excerpt",
        })
        .then(posts => {
            return posts;
        })
        .catch(err => {
            console.error(err);
        });

    if (!pageData) {
        return redirectTo500();
    }

    return {
        props: {
            pageData,
            postsData,
        },
        revalidate: 3600,
    };
}

const ServiceList = props => {
    return (
        <div>
            <Head>
                <title>Services | Offshore IT Services in Bangladesh</title>
                <meta
                    name="description"
                    content="DSi website for Projects and Services."
                />
            </Head>
            <div className="grid mid-home-column">
                <SingleService data={props.postsData}/>
            </div>
        </div>
    );
};

export default ServiceList;
